import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=2312ba63&scoped=true"
import script from "./TheNavbar.vue?vue&type=script&lang=ts"
export * from "./TheNavbar.vue?vue&type=script&lang=ts"
import style0 from "./TheNavbar.vue?vue&type=style&index=0&id=2312ba63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312ba63",
  null
  
)

export default component.exports